@if (isNavigating()) {
  <div class="nav-loader">
    <div class="nav-loader__spinner"></div>
    <span class="nav-loader__text">Loading…</span>
  </div>
}

<router-outlet />
